module.exports = __webpack_public_path__ + "media/60.d34c7562.mp4";